import { createTheme } from '@material-ui/core/styles'
import { alpha } from '@material-ui/core/styles'

import {
    //enUS,
    it
} from "date-fns/locale"

//import greenAnthilia from './colors/green-anthilia'
import greyAnthilia from './colors/grey-anthilia'
import grey from '@material-ui/core/colors/grey'
import green from '@material-ui/core/colors/green'
import red from '@material-ui/core/colors/red'
import amber from '@material-ui/core/colors/amber'
import blue from '@material-ui/core/colors/blue'

export const maxFileSize = 256 * 1024 * 1024 // 256 MB

//greenAnthilia.main = greenAnthilia[500]
//greenAnthilia.contrastText = '#fff'
grey.main = grey[600]
grey.contrastText = '#fff'
greyAnthilia.main = greyAnthilia[500]
const palette = {
    primary: grey,
    secondary: greyAnthilia,
    grey: grey,
    success: green,
    error: red,
    warning: amber,
    info: blue,
}
const assets_path = '/images'
const defaultTheme = createTheme()
const appHeaderBarHeight = 50
const appNavSideWidth = 250
export default createTheme({
    assets_path: assets_path,
    login_logo: assets_path+"/logo-login.png",
    navtop_logo: assets_path+"/logo.png",
    navtop_title: "Anthilia Sgr",
    navtop_showusername: false,
    palette: palette,
    locale: it,
    globals: {
        appHeaderBar: {
            //boxShadow: 'none',
            //color: 'white',
            color: palette.secondary.main,
            backgroundColor: 'white',
            //height: appHeaderBarHeight,
            minHeight: appHeaderBarHeight,
            borderRadius: 0,
        },
        appHeaderTitleBox: {
            flexGrow: 1,
        },
        appHeaderTitleText: {
            //fontWeight: 400,
            color: 'inherit',
        },
        appHeaderLogoBox: {
            marginRight: 20,
            height: appHeaderBarHeight,
            maxHeight: appHeaderBarHeight
        },
        appHeaderLogoImg: {
            height: '100%',
        },
        appHeaderNavTopBox: {
            color: 'inherit',
        },
        appNavTopItem: {
            textDecoration: 'none',
            color: 'inherit',
            marginLeft: '1%',
            marginRight: '1%'
        },
        appNavTopItemIcon: {
            paddingTop: 5,
            //textTransform: 'uppercase',
            //fontWeight: 500
        },
        appNavTopItemText: {
            paddingTop: 5,
            //textTransform: 'uppercase',
            //fontWeight: 500
        },
        appNavTopItemIconSelected: {
            color: palette.primary.main,
            fontWeight: 600,
        },
        appNavTopItemTextSelected: {
            color: palette.primary.main,
            fontWeight: 600
        },
        appNavTopItemDivider: {
            marginLeft: '1%',
            marginRight: '1%'
        },
        appUserAvatar: {
            width: 35,
            height: 35,
            lineHeight: 35,
            fontSize: '108%',
            backgroundColor: palette.secondary.main,
            textDecoration: 'none',
            '&:hover': {
                transform: 'scale(1.1)'
            },
            cursor:'pointer'
        },
        appNavSideDrawer: {
            width: appNavSideWidth,
            borderRadius: 0,
            //backgroundColor: 'transparent',
            //borderRight: 0,
        },
        appNavSideCloseBtn: {
            borderTop: '1px solid '+palette.grey[200],
        },
        appNavSideBlockTitle: {
            paddingBottom: 0,
            borderTop: '1px solid '+palette.grey[200],
        },
        appNavSideItem: {
            paddingLeft: defaultTheme.spacing(3)
        },
        appNavSideItemTitle: {
            paddingBottom: 0,
            fontWeight: 900,
            color: palette.grey[700],
        },
        appNavSideItemIcon: {
            minWidth: 30,
            color: palette.grey[600],
        },
        appNavSideItemText: {
            color: palette.grey[600],
        },
        appNavSideItemSelected: {
            backgroundColor: alpha(palette.primary.main,0.1),
            borderRight: "4px solid",
            borderRightColor: palette.primary.main,
            borderRadius: 0,
        },
        appNavSideItemIconSelected: {
            fontWeight: 900,
            color: palette.primary.main,
        },
        appNavSideItemTextSelected: {
            fontWeight: 900,
            color: palette.primary.main,
        },
        appNavSideItemTextInCollapsedSelected: {
            fontWeight: 900,
            color: palette.grey[700]
        },
        navSideUserBoxContainerClass: {
            borderBottom: '1px solid '+palette.grey[200],
        },
        navSideUserBox: {
            backgroundColor: palette.grey[100],
            borderRadius: 10,
            padding: defaultTheme.spacing(1),
            margin: defaultTheme.spacing(2),
        },
        navSideUserBoxNoUsername: {
            backgroundColor: 'transparent',
            padding: defaultTheme.spacing(1,0),
            margin: defaultTheme.spacing(2),
        },
        navSideUserText: {
            textDecoration: 'none',
            color: palette.grey[600]
        },
        appBody: {
            //---------height: 'calc(100% - 2*'+appHeaderBarHeight+'px)',
            paddingTop: appHeaderBarHeight,
            paddingBottom: appHeaderBarHeight,
        },
        appBodyNoHeader: {
            //---------height: 'calc(100% - '+appHeaderBarHeight+'px)',
            paddingBottom: appHeaderBarHeight,
        },
        appPageTitle: {
            marginTop: 15,
            marginBottom: 15,
            //color: palette.secondary.main,
            //fontWeight: 'bold'
        },
        appPageContent: {
            //---------minHeight: '80vh',
        },
        appFooter: {
            fontSize: '90%',
            fontWeight: 400,
            color: palette.grey[500],
            '& a': {
                textDecoration: 'none',
                color: 'inherit',
                fontWeight: 600,
            },
            '& a:hover': {
                color: palette.grey[700],
            },
        },
        FormMuiButton: {
            marginTop: 16,
        },
    },
    overrides: {
        MuiInput: {
            underline: {
                '&:hover:not($disabled):not($focused):not($error):before': {
                    borderBottomColor: palette.primary.main
                }
            },
        },
        MuiOutlinedInput: {
            root: {
                "&:hover:not($disabled):not($focused):not($error) $notchedOutline": {
                    borderColor: palette.primary.main
                }
            }
        },
        MuiToggleButton: {
            // La classe che Material-UI applica quando size="small"
            sizeSmall: {
                lineHeight: 1, // Imposta la line-height a 1 per la dimensione "small"
            },
            // Puoi aggiungere anche stili di default per tutti i ToggleButton se necessario:
            // root: {
            //   // Stili base per tutti i ToggleButton
            // },
            // Oppure stili specifici per i ToggleButton all'interno di un ToggleButtonGroup:
            // grouped: {
            //   // Questa classe viene applicata ai ToggleButton raggruppati
            // }
        },
        MuiToolbar: {
            regular: {
                // Sovrascrive la min-height di default
                minHeight: appHeaderBarHeight, 
                // Importante: MUI usa le media queries internamente. 
                // Per forzare la tua altezza ovunque, potresti dover resettare i breakpoint:
                '@media (min-width: 600px)': {
                    minHeight: appHeaderBarHeight, // o il valore che preferisci
                },
            },
        },
    },
})